import { useCallback, useState, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import useBrands from 'data/hooks/useBrands';
import partition from 'lodash/partition';
import uniqBy from 'lodash/uniqBy';

const useConnect = () => {
  const { push } = useHistory();
  const { pathname } = useLocation();
  const { isLoading, brands } = useBrands();
  const [openStatus, setOpenStatus] = useState(false);

  const baseRoute = pathname.split('/')[1];
  const titleLowercase = baseRoute.split('-').join(' ');
  const title =
    titleLowercase.charAt(0).toUpperCase() + titleLowercase.slice(1);

  const handleOpenStatus = useCallback(() => {
    setOpenStatus(true);
  }, [setOpenStatus]);

  const handleCloseStatus = useCallback(() => {
    setOpenStatus(false);
  }, [setOpenStatus]);

  const { integrationsOn, integrationsOff } = useMemo(() => {
    const allIntegrations = brands.flatMap((brand) => brand.integrations);

    const [integrationsActive, integrationsUnactives] = partition(
      allIntegrations,
      (integration) => integration.isActive,
    );

    const off = uniqBy(integrationsUnactives, 'id');
    const on = uniqBy(integrationsActive, 'id').filter(
      (integrationOff) =>
        !off.some((integrationOn) => integrationOn.id === integrationOff.id),
    );

    return {
      integrationsOn: uniqBy(on, 'image.src'),
      integrationsOff: uniqBy(off, 'image.src'),
    };
  }, [brands]);

  return {
    title,
    push,
    openStatus,
    handleOpenStatus,
    handleCloseStatus,
    isLoading,
    integrationsOn,
    integrationsOff,
  };
};

export default useConnect;
